import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as fieldsActions from '../../store/fields/actions';
import * as reducers from '../../store/reducers';
import { normalizeAPIError } from '../../errors';

import styles from './InviteSingleTeacherForm.scss';
import Form from 'Components/Form';
import Button from 'Components/Button';

class InviteSingleTeacherForm extends React.Component {
  constructor(props) {
    super(props);

    this.initialFieldSettings = this.initialFieldSettings.bind(this);
  }

  initialFieldSettings(value, response) {
    const message = response.response.msgId
      ? response.response
      : normalizeAPIError(response.response);
    return {
      username: {
        value,
        originalValue: value,
        showError: response.type === 'error',
        isValid: false,
        errorMsgId: message.msgId,
        stickyErrorMsgId: message.msgId,
        cannotMatch: message.errorCode === 30 ? value : undefined,
      },
    };
  }

  render() {
    const {
      email,
      response,
      formName,
      id,
      fields,
      position,
      schoolId,
    } = this.props;
    return (
      <div className="InviteSingleTeacherForm">
        <div className="InviteSingleTeacherForm__status">
          <Button
            buttonType="close"
            label=""
            ctaIcon="close"
            clickHandler={e => this.props.removeFormHanlder(email, id)}
          />
        </div>
        <div className="InviteSingleTeacherForm__form">
          <Form
            type={formName}
            id={id}
            formStyle="one-line"
            initialFieldSettings={this.initialFieldSettings(email, response)}
            initialFormSettings={{ isReconciling: true }}
            submitArgs={{ schoolId }}
            messagePosition="lightbox-internal"
            submitButtonType="secondary"
          />
        </div>
      </div>
    );
  }
}

InviteSingleTeacherForm.propTypes = {
  email: PropTypes.string.isRequired,
  error: PropTypes.object,
};

const mapStateToProps = (state, { email }) => {
  const formName = 'inviteSingleTeacher';
  const id = `${formName}_${email}`;
  return {
    formName,
    id,
    fields: reducers.getFormFields(state, id),
    formMessage: reducers.getFormMessage(state, id),
    schoolId: reducers.getActiveSchoolId(state),
    resultsByEmail: reducers.getInvitedTeachersResults(state),
  };
};

export default connect(mapStateToProps, {
  ...fieldsActions,
})(InviteSingleTeacherForm);
